<template>
    <div v-if="visible">
        <article data-locator="confirmation" class="box confirmation">
            <slot name="header">
                <header class="confirmation__header">
                    <h4 class="confirmation__title">
                        <slot name="title">Confirm</slot>
                    </h4>
                </header>
            </slot>
            <p class="confirmation__label"><slot>Are you sure?</slot></p>
            <p class="confirmation__item">{{ item }}</p>
            <p class="confirmation__label"><slot name="message"></slot></p>
        </article>
        <footer class="panel__footer">
            <button data-locator="cancel" type="button" class="button button--small button--outline" :disabled="busy" @click.prevent="hide">Cancel</button>
            <button data-locator="confirm" type="button" class="button button--small" :class="{'button--primary': danger === false, 'button--danger': danger === true}" :disabled="busy" @click.prevent="confirm"><slot name="confirm">Confirm</slot></button>
        </footer>
    </div>
</template>

<script>

export default {
    name: 'Confirm',

    props: {
        danger: {
            required: false,
            default: false
        }
    },

    data () {
        return {
            item: null,
            callback: null,
            visible: false,
            busy: false
        }
    },

    methods: {
        show (item, callback) {
            this.item = item
            this.callback = callback
            this.visible = true
            this.$emit('shown')
        },

        hide () {
            this.callback = null
            this.item = null
            this.busy = false
            this.visible = false
            this.$emit('hidden')
        },

        async confirm () {
            this.busy = true
            await this.callback()
            this.hide()
        }
    }
}
</script>
